
import Vue from 'vue'
import {Receive_ruleForm,Receive_valueArr} from './mutation-type'
export default{
  
    [Receive_ruleForm](state,{ruleForm}){
        state.ruleForm=ruleForm
    },
    [Receive_valueArr](state,{voluearr}){
        state.voluearr=voluearr
    },
    
}



// WEBPACK FOOTER //
// ./src/store/mutations.js